import { Icon } from '../../core/models/icon.model';

export const DEFAULT_DOMAIN_REGISTRATION_ICON: Icon = {
  name: 'language',
  type: 'material-icons',
};

/** Required field de domínio para Email Empresarial (não usar com_br_domain). */
export const EMAIL_DOMAIN_FIELD_NAME = 'email_domain';
